<app-searchform
  (showDataTable)="showDataTable($event)"
  (searchedData)="getTableRecords($event)"
  (searchFormData)="getSearchFormValues($event)"
></app-searchform>
<app-datatable #child style="display: flex"></app-datatable>
